export enum AbsolutePriceRuleType {
	FROM_PRICE_CATEGORY = "from-price-category",
	NETTO = "netto",
	BRUTO = "bruto",
	PROFIT = "profit",
	PROFIT_PERCENTAGE = "profit-percentage"
}

export class ProductBatchEditSellPricesBodyPricesAbsolutePriceRule {
	Type:AbsolutePriceRuleType = AbsolutePriceRuleType.FROM_PRICE_CATEGORY
	Value:number = 0.0;
	ToAddAmount:number = 0.0;
	ToAddAmountPercent:number = 0.0;
}